<iframe
  [src]="iframeUrl"
  [title]="getFrameTitle()"
  id="graphing-iframe"
  [class.is-locked]="isLocked"
  [attr.tabindex]="isLocked ? -1 : null"
  [attr.aria-disabled]="isLocked ? 'true' : null"
  [attr.inert]="isLocked ? '' : null"
  style="width: 508px; height: 608px;"
  (load)="handleFrameLoad()"
></iframe>
<p class="sr-only" role="status" aria-live="polite">{{ statusMessage }}</p>
